// components
import GridPageAbstract from '../../GridPageAbstract';
import { Profile2userBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class PartnersPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'partners';
        this.Server = this.props.context.getState().server.partners;
        this.hideSearch = false;
        this.searchFields = [
            'name',
            'contactEmail',
            // 'contactPhone',
            // 'comments'
        ];

        this.headerStartIcon = Profile2userBulkIcon;
        this.bannerImage = config?.bannerImages?.transactions || '';

        this.hiddenColumns = config?.hiddenColumns?.partners || [];

        this.Head = [
            { id: 'name', label: 'name', alignRight: false, cell: 'Text' },
            {
                id: 'logoFilesId',
                label: 'logoFile',
                cell: 'Upload',
                object: 'logoFile',
                fileType: 'merchant',
                fileParent: 'id',
                uploadType: 'single'
            },
            {
                id: 'contactEmail',
                label: 'contactEmail',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'contactPhone',
                label: 'contactPhone',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'comments',
                label: 'comments',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }
    customRetrieveData = async (list) => {
        const files = list.map((item) => item.logoFile);
        await this.preloadContextImages(files);
    };
}
